import _ from "lodash";
import React, { useState, useContext, useEffect } from "react";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import { serverTimesampToNormalDate } from "utils/AppUtils";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function OrderProductsTable({ modalOpen, orderId }) {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const getData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/order-products/order/${orderId}`);
      console.log("dataResponse", dataResponse);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    return data.map((obj) => {
      return {
        ...obj,
        className: obj.cancelledByUser ? "danger" : obj.payedByUser ? "success" : "",
        status: !obj.cancelledByUser && !obj.payedByUser ? t("common.labels.openSingular") : obj.cancelledByUser ? t("common.labels.cancelledSingular") : obj.payedByUser ? t("common.labels.paidSingular") : "",
        user: obj.payedByUser ? obj.payedByUser.name : obj.cancelledByUser ? obj.cancelledByUser.name : "-",
        color: obj.cancelledByUser ? "#8b0000" : obj.payedByUser ? "#63ca00" : "",
      };
    });
  };

  useEffect(() => {
    if (!orderId) return;
    if (modalOpen && orderId) getData();
  }, [orderId]);

  return (
    <Card className="regular-table-with-color">
      <Card.Body className="table-responsive p-0">
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <Table hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>{t("tables.headers.product")}</th>
                <th>{t("tables.headers.quantity")}</th>
                <th>{t("tables.headers.openingEuro")}</th>
                <th>{t("tables.headers.discountsEuro")}</th>
                <th>{t("tables.headers.totalEuro")}</th>
                <th>{t("tables.headers.payment")}</th>
                <th>{t("tables.headers.updatedAt")}</th>
                <th>{t("tables.headers.user")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.id} className={row.className}>
                  <td>{row.localId}</td>
                  <td>
                    {row.product.name}
                    {row.extra.length > 0 ? (
                      <div style={{ fontSize: "12px" }}>
                        {row.extra
                          .map((extra) =>
                            extra.extraPrefix ? extra.extraPrefix.extra_prefix_name + " " + extra.extra.extra_name : extra.extra.extra_name
                          )
                          .join(", ")}
                      </div>
                    ) : null}

                    {row.comments.length > 0 ? <div style={{ fontSize: "12px", marginTop: "0px" }}>{row.comments}</div> : null}
                  </td>
                  <td>{row.quantity}</td>
                  <td>{row.subTotal.toFixed(2)}</td>
                  <td>{row.discount.toFixed(2)}</td>
                  <td>{row.total.toFixed(2)}</td>
                  <td style={{ color: row.color }}>{_.get(row, "paymentMethod.name", "")}</td>
                  <td>{serverTimesampToNormalDate(row.localUpdatedAt)}</td>
                  <td>{row.user}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default OrderProductsTable;
